import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useTranslate } from '@repo/unicity'

const ErrorBox = ({ messages }: { messages: string[] }) => {
    const { translate } = useTranslate()
    return (
        <Stack
            direction={'column'}
            justifyContent={'center'}
            alignItems={'center'}
            paddingY="12px"
            sx={{
                borderRadius: '8px',
                backgroundColor: 'rgba(255, 231, 235, 1)',
                padding: '16px'
            }}>
            {messages.map((item, index) => (
                <Stack key={index} sx={{ width: '100%', textAlign: 'center' }}>
                    <Typography variant="error">{translate(item)}</Typography>
                    {index < messages.length - 1 && <Divider sx={{ border: '1px dashed #FE5D7C!important', margin: '8px 0px' }} />}
                </Stack>
            ))}
        </Stack>
    )
}

export default ErrorBox
